import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './HeroSection.css';
import bannerImg from '../assets/banner.jpg';
import bannerImg1 from '../assets/banner-1.jpeg';
import bannerImg2 from '../assets/banner-2.jpeg';

function HeroSection() {
    return (
        <div className="hero-carousel-container">
            <Carousel
                fade
                controls={false}
                indicators={true}
                interval={5000}
                pause={false}
                ride="carousel"
            >
                <Carousel.Item>
                    <div className="carousel-slide">
                        <div
                            className="carousel-image"
                            style={{ backgroundImage: `url(${bannerImg})` }}
                        ></div>
                        <div className="carousel-overlay">
                            <h2 className="animate__animated animate__fadeInUp">Welcome to
                                <br />Sri Sri Radha Madan Mohan Temple <br />
                            </h2>
                            <p className="animate__animated animate__fadeInUp animate__delay-1s">
                            Founder-Acharya: His Divine Grace A. C. Bhaktivedanta Swami Prabhupada
                            </p>
                        </div>

                    </div>
                </Carousel.Item>

                <Carousel.Item>
                    <div className="carousel-slide">
                        <div
                            className="carousel-image"
                            style={{ backgroundImage: `url(${bannerImg1})` }}
                        ></div>
                        <div className="carousel-overlay">
                            <h2 className="fade-in">Chant and Be Happy</h2>
                            <p className="animate__animated animate__fadeInUp animate__delay-1s">
                                Join the Hare Krishna movement and awaken your inner peace.</p>
                        </div>
                    </div>
                </Carousel.Item>

                <Carousel.Item>
                    <div className="carousel-slide">
                        <div
                            className="carousel-image"
                            style={{
                                backgroundImage: `url(${bannerImg2})`
                            }}
                        ></div>
                        <div className="carousel-overlay">
                            <h2 className="fade-in">Spiritual Events</h2>
                            <p className="animate__animated animate__fadeInUp animate__delay-1s">
                                Celebrate Krishna consciousness with kirtans, lectures, and prasadam.
                            </p>
                        </div>
                    </div>
                </Carousel.Item>
            </Carousel>
        </div>
    );
}

export default HeroSection;
